<div class="sivu">
  <mat-form-field class="putki-kentta" subscriptSizing="dynamic">
    <mat-label>Putki</mat-label>
    <mat-select [formField]="putkiKentta">
      @for (putki of putket; track putki) {
        <mat-option [value]="putki">{{ putkenNimi[putki] }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (lataa()) {
    <mat-spinner diameter="32"></mat-spinner>
  } @else {
    @if (uusin()) {
      <div class="aktiivinen-versio">
        Aktiivinen versio: <strong>v{{ uusin().versio }}</strong> — päivitetty {{ uusin().paivitetty | date: 'dd.MM.yyyy HH:mm' }}
        @if (uusin().paivittajaUid) {
          <span> ({{ annaPaivittajanNimi(uusin().paivittajaUid) }})</span>
        }
      </div>
    } @else {
      <p class="ei-versioita">Putkella ei ole vielä promptiversioita. Liitä tuotannon prompti editoriin ja tallenna se ensimmäiseksi versioksi.</p>
    }

    <p class="selite-teksti">{{ putkenSelite[valittuPutki()] }}</p>

    <mat-form-field class="prompti-kentta">
      <mat-label>Tositteen luvun prompti</mat-label>
      <textarea matInput [formField]="muokattuKentta" class="prompti-textarea"></textarea>
    </mat-form-field>

    <div class="toimintorivi">
      <app-primary-button (click)="tallenna()" [disabled]="tallennetaan() || !muokattuKentta().value().trim() || !onMuutoksia" actionId="Tallenna tositteen luvun promptversio">
        @if (tallennetaan()) {
          <mat-spinner diameter="18" class="nappi-spinner"></mat-spinner>
        }
        Tallenna uusi versio
      </app-primary-button>
      <app-button (click)="toggleHistoria()" [matIcon]="naytaHistoria() ? 'expand_less' : 'expand_more'" actionId="Näytä/piilota tositteen luvun promptihistoria">Versiohistoria</app-button>
    </div>

    @if (naytaHistoria()) {
      <div class="historia-lohko">
        @if (historiaLataa()) {
          <mat-spinner diameter="24"></mat-spinner>
        } @else if (historia().length > 1) {
          <table class="historia-taulukko">
            <tr class="historia-otsikkorivi">
              <th class="historia-th">Versio</th>
              <th class="historia-th">Päivitetty</th>
              <th class="historia-th">Päivittäjä</th>
              <th class="historia-th">Esikatselu</th>
              <th class="historia-solu"></th>
            </tr>
            @for (v of historia(); track v.versio) {
              <tr class="historia-rivi">
                <td class="historia-versio-solu">v{{ v.versio }}</td>
                <td class="historia-solu">{{ v.paivitetty | date: 'dd.MM.yyyy HH:mm' }}</td>
                <td class="historia-solu">{{ annaPaivittajanNimi(v.paivittajaUid) }}</td>
                <td class="historia-prompti-solu">{{ v.prompt | slice: 0 : 80 }}{{ v.prompt.length > 80 ? '…' : '' }}</td>
                <td class="historia-solu">
                  <app-button (click)="esikatsele(v)" actionId="Esikatsele tositteen luvun promptversio">Näytä</app-button>
                  <app-button (click)="palautaVersio(v.versio)" actionId="Palauta tositteen luvun promptversio">Palauta</app-button>
                </td>
              </tr>
            }
          </table>
        } @else {
          <p class="ei-historiaa">Ei aiempia versioita.</p>
        }
      </div>
    }

    @if (esikatseluVertailu()) {
      <app-prompti-versiovertailu [vertailu]="esikatseluVertailu()" (palauta)="palautaVersio($event)" (sulje)="suljeEsikatselu()"></app-prompti-versiovertailu>
    }
  }
</div>
